module.exports = __webpack_public_path__ + "static/media/logo.091d4441.png";